import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class AutoGroupGrid extends BaseComponent {
	
	static get properties() {
		return {
			admin: {type: Boolean}
		};
	}
	
	constructor() {
		super();
						
		this.admin = false;	
		
		var autoGroupGrid = this;
		setTimeout(function(){
			autoGroupGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var autoGroupGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['AUTOGROUP_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['AUTOGROUP_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'dl-action-button',						
					theme: 'error primary',
					itemid: 'delete',
					disabled: true,
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					permissions: ['AUTOGROUP_MANAGEMENT:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}									
			]
		});		
			
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [	
				{						
					path: 'autoGroupId',
					header: 'Config Id',
					width: '7em'
				},
				{						
					path: 'name',
					header: 'Config Name',
					width: '7em'
				},
				{						
					path: 'dataType',
					header: 'Data Type',
					width: '7em'
				},
				{						
					path: 'groupCodeField',
					header: 'Group Code Field',
					width: '9em'
				},
				{						
					path: 'additionalGroupFields',
					header: 'Additional Fields',
					width: '9em',
					renderer: function(root, column, rowData) {
						var fields = rowData.item.additionalGroupFields;
						if (fields && fields.length) {
							root.textContent = fields.join(', ');
						} else {
							root.textContent = '';
						}
					}
				},
				{						
					path: 'assignTractor',
					header: 'Assign Tractor',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'assignTrailer',
					header: 'Assign Trailer',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'assignDriver',					
					header: 'Assign Driver',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'keepGroupHistory',					
					header: 'Keep History',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'activeStatus',
					header: 'Active Status',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},								
				{						
					path: 'updateUser',
					header: 'Update User',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		autoGroupGrid.append(flexLayout);		
			
		var actionRefresh = function() {	
			var loadMask = grid.showLoading();
			UnitService.getAutoGroupService().getAutoGroupConfigs().then(function(data){
				loadMask.remove();
				
				grid.activeItem = null;
				grid.items = data;	
			});			
		};
		actionRefresh();
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit' : 'Add',
				icon: 'vaadin:edit',				
				width: .75,
				height: 620,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var fieldCombo;
						var additionalFieldsGrid;
						var availableFields = [];
						var loadFields = function(dataType, clearSelection) {
							if (!fieldCombo) {
								return;
							}
							if (clearSelection) {
								fieldCombo.value = null;
								fieldCombo.items = [];
								if (additionalFieldsGrid) {
									additionalFieldsGrid.items = [];
									additionalFieldsGrid.selectedItems = [];
								}
							}
							if (!dataType) {
								availableFields = [];
								return;
							}
							UnitService.getAutoGroupService().getFieldDefinitions(dataType).then(function(definition) {
								var fields = (definition && definition.dataField) ? definition.dataField : [];
								availableFields = fields;
								fieldCombo.items = fields;
								
								fieldCombo.required = true;
							});
						};

						var actionAddAdditionalField = function() {
							if (!availableFields || availableFields.length === 0) {
								window.DL.MessageUtil.showToast('Select Data Type', 'Choose a data type before adding additional fields.', {
									theme: 'contrast'
								});
								return;
							}
							var addFieldWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Add Additional Group Field',
								icon: 'vaadin:plus',
								width: 480,
								height: 220,
								listeners: {
									ready: function() {
										addFieldWin.show();
										var addForm = ElementUtil.create({
											tag: 'dl-form-panel',
											children: [
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'vaadin-combo-box',
															name: 'fieldPath',
															label: 'Group Field',
															required: true,
															'item-value-path': 'fieldPath',
															'item-label-path': 'name',
															placeHolder: 'Select',
															postinit: function(combo) {
																combo.items = availableFields.slice();
															}
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															children: [
																{
																	tag: 'vaadin-button',
																	theme: 'primary',
																	innerHTML: 'Add',
																	listeners: {
																		click: function() {
																			addForm.submitForm({
																				preSubmit: function(data) {
																					return data;
																				},
																				actualCall: function(data) {
																					var selected = availableFields.find(function(field) {
																						return field.fieldPath === data.fieldPath;
																					});
																					var current = (additionalFieldsGrid.items || []).slice();
																					var exists = current.some(function(item) {
																						return item.fieldPath === data.fieldPath;
																					});
																					if (!exists && selected) {
																						current.push({
																							fieldPath: selected.fieldPath,
																							name: selected.name
																						});
																						additionalFieldsGrid.items = current;
																					}
																					addFieldWin.close();
																					return Promise.resolve(data);
																				},
																				success: function() {}
																			});
																		}
																	}
																},
																{
																	tag: 'vaadin-button',
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			addFieldWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});
										addFieldWin.addToContentElement(addForm);
									}
								}
							});
						};

						var actionRemoveAdditionalField = function() {
							if (!additionalFieldsGrid || additionalFieldsGrid.selectedItems.length === 0) {
								return;
							}
							var removePath = additionalFieldsGrid.selectedItems[0].fieldPath;
							additionalFieldsGrid.items = (additionalFieldsGrid.items || []).filter(function(item) {
								return item.fieldPath !== removePath;
							});
							additionalFieldsGrid.selectedItems = [];
							var removeBtn = ElementUtil.query(formPanel, 'removeAdditionalField');
							if (removeBtn) {
								removeBtn.disabled = true;
							}
						};

						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',										
											name: 'name',
											label: 'Name',
											required: true,
											maxLength: 120											
										},
										{
											tag: 'vaadin-combo-box',					
											name: 'dataType',
											label: 'Data Type',										
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('DataType').then(function (data) {
													var supported = [];
													data.forEach(function(item) {
														if (item.supportsAutoGroup) {
															supported.push(item);
														}
													});
													combo.items = supported;													
												});
											},
											listeners: {
												change: function(event) {
													var selected = event.target.value;
													loadFields(selected, true);
												}
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-combo-box',
											name: 'groupCodeField',
											label: 'Group Code Field',											
											'item-value-path': 'fieldPath',
											'item-label-path': 'name',
											postinit: function (combo) {
												fieldCombo = combo;
												if (record && record.dataType) {
													loadFields(record.dataType, false);														
												}												
											},
											placeHolder: 'Select'
										},
										{
											tag: 'div',
											colspan: 2,
											style: 'margin-top: 8px;',
											children: [
												{
													tag: 'div',
													style: 'font-weight: 600; margin-bottom: 4px;',
													innerHTML: 'Additional Group Fields'
												},
												{
													tag: 'div',
													style: 'font-size: 0.85em; color: var(--lumo-secondary-text-color); margin-bottom: 6px;',
													innerHTML: 'Optional. Each field creates/adds group memberships without switching (e.g. Tags). Single-field configs can leave this empty.'
												},
												{
													tag: 'dl-toolbar',
													theme: 'spacing',
													style: 'margin-bottom: 4px;',
													children: [
														{
															tag: 'vaadin-button',
															theme: 'primary',
															'class': 'spacer-toolbar-item',
															children: [
																ElementUtil.makeIcon('vaadin:plus', ' Add Field')
															],
															listeners: {
																click: function() {
																	actionAddAdditionalField();
																}
															}
														},
														{
															tag: 'vaadin-button',
															theme: 'error primary',
															itemid: 'removeAdditionalField',
															disabled: true,
															'class': 'spacer-toolbar-item',
															style: 'float: right;',
															children: [
																ElementUtil.makeIcon('vaadin:trash', ' Remove')
															],
															listeners: {
																click: function() {
																	actionRemoveAdditionalField();
																}
															}
														}
													]
												},
												{
													tag: 'vaadin-grid',
													itemid: 'additionalGroupFieldsGrid',
													theme: 'row-stripes column-borders compact',
													style: 'height: 140px; width: 100%;',
													children: [
														{
															tag: 'vaadin-grid-column',
															header: 'Group Field',
															path: 'fieldPath',
															flexGrow: 1,
															renderer: function(root, column, rowData) {
																var label = rowData.item.name || rowData.item.fieldPath || '';
																root.textContent = label + (rowData.item.fieldPath ? ' (' + rowData.item.fieldPath + ')' : '');
															}
														}
													],
													listeners: {
														'active-item-changed': function(event) {
															var item = event.detail.value;
															var gridElement = event.target;
															if (!gridElement) {
																return;
															}
															gridElement.selectedItems = item ? [item] : [];
															if (!formPanel) {
																return;
															}
															var removeBtn = ElementUtil.query(formPanel, 'removeAdditionalField');
															if (removeBtn) {
																removeBtn.disabled = gridElement.selectedItems.length === 0;
															}
														}
													}
												}
											]
										},
										{
											tag: 'vaadin-checkbox',
											name: 'assignTractor',
											label: 'Assign Tractor',
											checked: true
										},
										{
											tag: 'vaadin-checkbox',
											name: 'assignTrailer',
											label: 'Assign Trailer'
										},
										{
											tag: 'vaadin-checkbox',
											name: 'assignDriver',
											label: 'Assign Driver'
										},
										{
											tag: 'vaadin-checkbox',
											name: 'keepGroupHistory',
											label: 'Keep Group History On Switch',
											'helper-text': 'When switching groups, write unit group history. Off by default for Data Link chargeback reporting.'
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																												
															formPanel.submitForm({
																preSubmit: function(data) {
																	if (data.assignTractor === undefined) {
																		data.assignTractor = false;
																	}
																	if (data.assignTrailer === undefined) {
																		data.assignTrailer = false;
																	}
																	if (data.assignDriver === undefined) {
																		data.assignDriver = false;
																	}
																	if (data.keepGroupHistory === undefined) {
																		data.keepGroupHistory = false;
																	}
																	data.additionalGroupFields = (additionalFieldsGrid.items || []).map(function(item) {
																		return item.fieldPath;
																	});
																	return data;
																},
																actualCall: function(data) {			
																	if (record) {
																		data.autoGroupId = record.autoGroupId;
																	}
																	return UnitService.getAutoGroupService().saveAutoGroup(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Auto Group Config', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						additionalFieldsGrid = ElementUtil.query(formPanel, 'additionalGroupFieldsGrid');
						
						if (record) {	
							formPanel.load(record);
							if (additionalFieldsGrid && record.additionalGroupFields) {
								additionalFieldsGrid.items = record.additionalGroupFields.map(function(fieldPath) {
									return {
										fieldPath: fieldPath,
										name: fieldPath
									};
								});
							}
						} else {
							formPanel.load({
								assignTractor: true,
								assignTrailer: false,
								assignDriver: false,
								keepGroupHistory: false
							});
						}
					}
				}
			});			
		};
		
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: '<b>Are you sure you want to delete "' + record.name + '"?</b> <br><i class="fas fa-exclamation-triangle warning-icon"></i>This config will be removed from associated Integrations.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							UnitService.getAutoGroupService().deleteAutoGroup(record.autoGroupId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed '+ record.name, {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};	
		
	}
	
}
customElements.define('dl-autogroup-grid', AutoGroupGrid);
